import {useState} from "react";
import { useFetchData } from "../../hooks/useFetchData";
import CollectionCard from "./CollectionCard";
import AccountsCard from "./AccountsCard";
import PendingAccountsCard from "./PendingAccountsCard";
import Locations from "../Locations";

const DashboardCard = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const locations = JSON.parse(localStorage.getItem("agentLocations"));
  const location = JSON.parse(localStorage.getItem("locations"));
  const [locationName, setLocationName] = useState(
    location[location.length - 1].name
  );
  const userId = location[location.length - 1].id;
  const [locationId, setLocationId] = useState(userId);
  let userLocations = []
  if (locations.length > 1) {
    locations.forEach((location) => {
      userLocations = [...userLocations, location[4]];
    })
  }
  const handleRadioChange = (location) => {
    setLocationId(location.id);
    setLocationName(location.name);
  };
  // Fetch accounts data
  const accountsUrl = `reports/accounts/dashboard?location=${locationId}`;
  const { data: accountsData } = useFetchData(
    ["fetch-accounts-data",locationId],
    accountsUrl,true,user
  );
  const datafromChildComponent = (data) => {
    setLocationId(data.locationId);
    setLocationName(data.locationName);
  };
  const Loading = () => (
    <img src='/assets/img/loading.gif' alt='loading' width={100} height={100} />
  );
  return (
    <>
      <Locations sendDataToParent={datafromChildComponent} />
      {userLocations?.length > 1 &&
        userLocations.some((location) => location !== undefined) && (
          <div
            className='d-flex justify-content-center mt-2'
            style={{ gap: 20 }}
          >
            {userLocations?.map((location) => (
              <div key={location?.id}>
                <input
                  type='radio'
                  name='role'
                  value={location?.id}
                  checked={location?.id === locationId}
                  onChange={() => handleRadioChange(location)}
                />
                <label className='ml-1'>{location?.name}</label>
              </div>
            ))}
          </div>
        )}
      <div className='d-flex justify-content-center mt-2'>
        <h3>{locationName}</h3>
      </div>
      <div className='d-flex flex-wrap p-3' style={{ gap: 20 }}>
        {/* Collection card */}
        <CollectionCard locationId={locationId} loading={Loading} />
        {/* Accounts card */}
        <AccountsCard
          accountsData={accountsData}
          locationName={locationName}
          loading={Loading}
        />
        {/* Pending accounts card */}
        <PendingAccountsCard
          locationId={locationId}
          accountsData={accountsData}
          loading={Loading}
        />
      </div>
    </>
  );
};

export default DashboardCard;
